import { render, staticRenderFns } from "./StakingRecords.vue?vue&type=template&id=fce883ba&scoped=true"
import script from "./StakingRecords.vue?vue&type=script&lang=js"
export * from "./StakingRecords.vue?vue&type=script&lang=js"
import style0 from "./StakingRecords.vue?vue&type=style&index=0&id=fce883ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce883ba",
  null
  
)

export default component.exports